const ActivityType = Object.freeze({
  INCOME_ACTIVITY: "INCOME_ACTIVITY",
  CASH_ACTIVITY: "CASH_ACTIVITY",
  ASSET_BUY_ACTIVITY: "ASSET_BUY_ACTIVITY",
  ASSET_SELL_ACTIVITY: "ASSET_SELL_ACTIVITY",
});

export default ActivityType;
